import { FC } from 'react';
import { Box, BoxProps, Text } from '@chakra-ui/react';
import { CbLink } from '../CbLink';
import { Link } from '../../types/Link';
import { getIdentifiers } from '../../helpers';
import styles from './CbFooter.module.css';
export interface CbFooterProps extends BoxProps {
  links: Link[];
  text: string;
}
export const CbFooter: FC<CbFooterProps> = ({
  links,
  text,
  ...props
}) => {
  return <Box className={styles.footer} as="footer" {...props} data-sentry-element="Box" data-sentry-component="CbFooter" data-sentry-source-file="CbFooter.tsx">
      <Box className={styles.footerContent} data-sentry-element="Box" data-sentry-source-file="CbFooter.tsx">
        <Text color="cloud.700" display="inline-block" fontSize="sm" marginRight={8} data-sentry-element="Text" data-sentry-source-file="CbFooter.tsx">
          {text}
        </Text>
        {links.map(link => <CbLink color="cloud.700" display="inline-block" fontSize="sm" href={link.href} isExternal key={link.label} marginRight={8} paddingY={2} textDecoration="underline">
            {link.label}
          </CbLink>)}
        <IdentifierDisplay data-sentry-element="IdentifierDisplay" data-sentry-source-file="CbFooter.tsx" />
      </Box>
    </Box>;
};
const IdentifierDisplay: FC = () => {
  const {
    entityId,
    server
  } = getIdentifiers();
  if (!entityId || !server) return null;
  return <Text fontSize="xs" opacity={0.6} data-sentry-element="Text" data-sentry-component="IdentifierDisplay" data-sentry-source-file="CbFooter.tsx">
      {`${server} Entity: ${entityId}`}
    </Text>;
};